import { Loader2, Inbox, FlaskConical } from "lucide-react";

export const PageHeader = ({ icon: I, color = "#135c37", title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end gap-4 mb-6 jt-fade">
    <div className="flex items-center gap-3.5 flex-1 min-w-0">
      {I && <span className="w-12 h-12 rounded-2xl flex items-center justify-center shrink-0" style={{ background: `${color}18` }}><I className="w-6 h-6" style={{ color }} /></span>}
      <div className="min-w-0">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-[var(--jt-emerald)] tracking-tight">{title}</h2>
        {subtitle && <p className="text-sm sm:text-base text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, hint, icon: I, color = "#135c37", big, testid, className = "" }) => (
  <div className={`jt-card p-4 sm:p-5 flex gap-3.5 items-start ${className}`} data-testid={testid}>
    {I && <span className={`${big ? "w-14 h-14" : "w-11 h-11"} rounded-2xl flex items-center justify-center shrink-0`} style={{ background: `${color}18` }}><I className={big ? "w-7 h-7" : "w-5 h-5"} style={{ color }} /></span>}
    <div className="min-w-0">
      <div className={`${big ? "text-base" : "text-[13px]"} font-bold text-foreground/80`}>{label}</div>
      <div className={`${big ? "text-2xl sm:text-[2rem]" : "text-xl"} font-extrabold tracking-tight mt-0.5 break-words`} style={{ color }} data-testid={testid && `${testid}-value`}>{value}</div>
      {hint && <div className="text-xs sm:text-[13px] text-muted-foreground mt-1 leading-snug">{hint}</div>}
    </div>
  </div>
);

export const Field = ({ label, children, className = "", hint }) => (
  <label className={`block ${className}`}>
    <span className="block text-sm font-bold mb-1.5">{label}</span>
    {children}
    {hint && <span className="block text-xs text-muted-foreground mt-1">{hint}</span>}
  </label>
);

export function RupiahInput({ value, onChange, testid, placeholder = "0", ...rest }) {
  const show = value ? Number(value).toLocaleString("id-ID") : "";
  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm font-semibold text-muted-foreground">Rp</span>
      <input className="jt-input pl-10 text-right font-semibold" inputMode="numeric" placeholder={placeholder} value={show}
        onChange={(e) => onChange(Number(e.target.value.replace(/\D/g, "").slice(0, 13)) || 0)} data-testid={testid} {...rest} />
    </div>
  );
}

export const QtyInput = ({ value, onChange, testid, ...rest }) => (
  <input className="jt-input" inputMode="decimal" placeholder="0" value={value}
    onChange={(e) => onChange(e.target.value.replace(",", ".").replace(/[^\d.]/g, ""))} data-testid={testid} {...rest} />
);

const BADGE = {
  Aman: "bg-[#e3f3e5] text-[#1f6b39]", "Mulai Menipis": "bg-[#fde8e4] text-[#b4412b]", Habis: "bg-red-100 text-red-700",
  "Belum Dibayar": "bg-[#fde8e4] text-[#b4412b]", "Dibayar Sebagian": "bg-[#fdf0d2] text-[#8a6212]", Lunas: "bg-[#e3f3e5] text-[#1f6b39]",
  Dibatalkan: "bg-gray-200 text-gray-600",
};
export const StatusBadge = ({ status, testid }) => (
  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap ${BADGE[status] || "bg-gray-100"}`} data-testid={testid}>{status}</span>
);
export const SimBadge = () => (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold bg-[#fdf3d8] text-[#8a6212] border border-[#e9d39a]" data-testid="sim-record-badge">
    <FlaskConical className="w-3 h-3" /> Contoh
  </span>
);

export const Loading = ({ text = "Memuat data..." }) => (
  <div className="flex items-center justify-center gap-2 py-10 text-muted-foreground text-sm" data-testid="loading-state"><Loader2 className="w-5 h-5 animate-spin" /> {text}</div>
);
export const EmptyState = ({ text, testid = "empty-state" }) => (
  <div className="flex flex-col items-center justify-center text-center py-10 px-4 text-muted-foreground" data-testid={testid}>
    <Inbox className="w-9 h-9 mb-2 opacity-50" /><p className="text-sm">{text}</p>
  </div>
);
export const SectionTitle = ({ children, right }) => (
  <div className="flex items-center justify-between gap-3 mb-3"><h3 className="text-base sm:text-lg font-extrabold text-[var(--jt-emerald)]">{children}</h3>{right}</div>
);
